import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';

// eslint-disable-next-line no-unused-vars
const statusName = [
  { value: '1', label: 'Active' },
  { value: '2', label: 'Expired' },
];

const xenditStatusName = [
  { value: 'success', label: 'PAID' },
  { value: 'pending', label: 'PENDING' },
  { value: 'expired', label: 'EXPIRED' }
];

const paymentStatusName = [
  { value: 'failed', label: 'FAILED' },
  { value: 'pending', label: 'PENDING' },
  { value: 'success', label: 'SUCCESS' }
];

const searchOptions = [
    { value: 'dealer_name', label: 'Dealer Name', allow_for: ['admin'] },
    { value: 'dealer_id', label: 'Dealer ID', allow_for: ['admin'] },
    { value: 'transaction_id', label: 'Transaction ID', allow_for: ['admin', 'dealer'] },
    { value: 'sku_name', label: 'SKU Name', allow_for: ['admin', 'dealer'] }
];

const SkuTransactionFilters = ({ filters, onFilterChange, onReset, fetchTransactionList, handleApplyFilters, isAdmin }) => {
    const filteredSearchOptions = searchOptions.filter(opt =>
        isAdmin ? opt.allow_for.includes('admin') : opt.allow_for.includes('dealer')
    );
    return (
        <Form>
            <div className="m-sm sku-input">
                <Form.Label>Search By</Form.Label>
                <Select
                    value={filteredSearchOptions.find((sobj) => sobj.value === filters.search_by) || ''}
                    onChange={(val) => onFilterChange('search_by', val)}
                    options={filteredSearchOptions}
                    placeholder="Select By"
                />
            </div>
            <div className="dealer-name m-sm">
                <Form.Label>
                    {filteredSearchOptions.find((sobj) => sobj.value === filters.search_by)?.label || 'Search Value'}
                </Form.Label>
                <Form.Control
                    value={filters.search_value}
                    placeholder={`Enter ${filteredSearchOptions.find((sobj) => sobj.value === filters.search_by)?.label || 'value'}`}
                    onChange={(e) => onFilterChange('search_value', e.target.value)}
                    disabled={!filters?.search_by}
                />
            </div>

            {/* <div className="dealer-name m-sm">
                <Form.Label>Search By Dealer Name or GCD Code</Form.Label>
                <Form.Control
                    value={filters.search}
                    placeholder="Search by Dealer Name, GCD Code and transaction id"
                    onChange={(e) => onFilterChange('search', e.target.value)}
                />
            </div> */}

            {isAdmin && <div className="m-sm city-input">
                <Form.Label>Xendit Status</Form.Label>
                <Select
                    value={xenditStatusName?.find(st => st.value === filters.xendit_status) || ''}
                    onChange={(val) => onFilterChange('xendit_status', val)}
                    options={xenditStatusName}
                />
            </div>}

            <div className="m-sm city-input">
                <Form.Label>Payment Status</Form.Label>
                <Select
                    value={paymentStatusName?.find(st => st.value === filters.payment_status) || ''}
                    onChange={(val) => onFilterChange('payment_status', val)}
                    options={paymentStatusName}
                />
            </div>

            <Button
                variant="solid bg-orange w-auto m-xs-l"
                type="button"
                // onClick={() => fetchTransactionList(1)}
                onClick={() => handleApplyFilters()}
            >
                Search
            </Button>
            <Button
                variant="default m-sm-l"
                type="button"
                onClick={onReset}
            >
                Reset
            </Button>
        </Form>
    );
};

export default SkuTransactionFilters;
